import styled from 'styled-components';

import { setTypography } from 'utils/styles/mixins';

export default styled.div`
  ${setTypography('body1')}
`;
